export default __webpack_public_path__ + "static/media/5.8436b593.png";